<script setup lang="ts">
import { faFacebook, faLinkedin, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

</script>

<template>
    <nav class="top-nav">
        <aside class="aside aside-left">
            <ul>
                <li class="text-social">Visita nuestras redes</li>
                <li><a href="https://www.facebook.com/rodamientoshuanuco.ramos" target="_blank" rel="noopener noreferrer"><font-awesome-icon :icon="faFacebook" /></a></li>
                <li><a href="https://www.tiktok.com/@rodamientoshuanuc" target="_blank" rel="noopener noreferrer"><font-awesome-icon :icon="faTiktok" /></a></li>
                <li><a href="https://www.linkedin.com/in/rodamientos-huanuco-e-i-r-l-a5943048/?originalSubdomain=pe" target="_blank" rel="noopener noreferrer"><font-awesome-icon :icon="faLinkedin" /></a></li>
            </ul>
        </aside>
        <aside class="aside aside-rigth">
            <ul>
                <li><a> <FontAwesomeIcon :icon="faPhone" /> &nbsp;<span class="text-number">(01) 224-8385</span></a></li>
                <li><a href="https://maps.app.goo.gl/eagcpWhMRhJA777N6" target="_blank" rel="noopener noreferrer"><font-awesome-icon :icon="faLocationDot"/> &nbsp; <span class="text-location">Av. Aviacion 1954 La Victoria, Lima Perú</span></a></li>
            </ul>
            
        </aside>
    </nav>
</template>

<style lang="scss">
.top-nav {
    background-color: $tint1;
    padding-inline: 300px;
    padding-block: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .aside {
        display: flex;
    }
    .aside ul {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 20px;
        list-style: none;
        margin: 0;
        font-size: 14px;
        color: $whited;
    }
    .aside-left a {
        color: $whited;
    }
    .aside-rigth a {
        color: $whited;
        text-decoration: none;
        img {
            width: 14px;
        }
    }
}

@media (max-width: 1600px) {
    .top-nav {
        padding-inline: 100px;
    }
}

@media (max-width: 1080px) {
    .top-nav {
        padding-inline: 80px;
        .aside-left {
            .text-social {
                display: none;
            }
        }
    }
}

@media (max-width: 780px) {
    .top-nav {
        .aside-rigth {
            li {
                a {
                    display: flex;
                    align-items: center;
                    background-color: $colorPrimary;
                    padding: 10px;
                    height: 40px;
                    border-radius: 20%;
                }
                img {
                    width: 20px;
                    margin: 0 auto;
                }
            }
            .text-number {
                display: none;
            }
            .text-location {
                display: none;
            }
        }
    }
}

@media (max-width: 580px) {
    .top-nav {
        padding-inline: 20px;
    }
}
</style>